import React, { useEffect, useState } from "react";
import { RiShutDownLine, RiShareBoxFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import socket from "../../../../CommonFunction/SocketClient";
import { AccountDetails } from "../../FormComponents";
import { gql, useLazyQuery, useQuery } from "@apollo/client";
import { AccountTrackingBalanceAndPlan } from "../../../../Utils/AllPagesQuriesAndMutations";
import Button from "../../Button/Button";
import Spinner from "../../Spinner/Spinner";

const loaginDetailsFetch = gql`
  query Login($loginInput: LoginInput!) {
    login(loginInput: $loginInput) {
      token
      LicenseeCode
      userDetails {
        _id
        Account_ID
        User_ID
        Default_Company {
          _id
          Unique_Id
          Name
          Search_Value
          Address
          State
          City
          Pincode
          Status
          Company_Code
          Email
          GST_Number
          createdAt
          updatedAt
        }
        Default_Branch {
          _id
          Unique_Id
          Name
          Branch_Code
          Company_ID
          Search_Value
          Address
          State
          City
          Pincode
          Email
          Mobile_Number
          GST_Number
          createdAt
          updatedAt
        }
        Department
        Mobile
        Email
        Full_Name
        UserName
        Password
        Role {
          _id
          Unique_Id
          Role
          RoleType
          Copy_Role_From
          Back_Year_View_Rights
          Module_Rights
          createdAt
          updatedAt
        }
        Is_Active
        View_Only_Self_Entry
        View_Only_Current_Year
        Super_Access_User
        Allow_Audit
        Merge_Balance
        createdAt
        updatedAt
      }
      message
      BookMarks {
        Page_Rights {
          _id
          Unique_Id
          Page_Name
          Page_Access
          Role_Id
          Route
          Module_Right_Id
          Page_Id
          Is_Add
          Is_View
          Is_Edit
          Is_Delete
          Is_Merge
          Export
          Is_Lock
          Is_Unlock
          Audit
          UnAudit
          Serial_No
          createdAt
          updatedAt
        }
      }
      CompanyAccess {
        _id
        Unique_Id
        Company_ID {
          _id
          Unique_Id
          Name
          Search_Value
          Address
          State
          City
          Pincode
          Status
          Company_Code
          Email
          GST_Number
          createdAt
          updatedAt
        }
        BranchAccess_Code {
          _id
          Unique_Id
          Name
          Branch_Code
          Company_ID
          Search_Value
          Address
          State
          City
          Pincode
          Email
          Mobile_Number
          GST_Number
          createdAt
          updatedAt
        }
        User_ID
        createdAt
        updatedAt
      }
      PageRightsAccess {
        _id
        Unique_Id
        Menu_Name
        createdAt
        updatedAt
        Modules {
          _id
          Unique_Id
          Module_Access
          Module_Id
          Menu_Id
          Module_Name
          createdAt
          updatedAt
          Page {
            _id
            Unique_Id
            Page_Name
            Page_Access
            Role_Id
            Route
            Module_Right_Id
            Page_Id
            Is_Add
            Is_View
            Is_Edit
            Is_Delete
            Is_Lock
            Is_Unlock
            Export
            Audit
            UnAudit
            createdAt
            updatedAt
          }
        }
      }
    }
  }
`;
function UserInfo(props) {
  const [isAccountID, setIsAccountID] = useState(false);
  const [accountData, setAccountData] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const today = new Date();
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1;
  let dd = today.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");

  const [fetchAccountDetails] = useLazyQuery(AccountTrackingBalanceAndPlan, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [fetchLoginQueryResult, { loading: loginQueryLoading }] = useLazyQuery(loaginDetailsFetch, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    fetchAccountDetails().then((res) => {
      if (res) {
        // console.log(res, "AAAAAAAY");
        setAccountData(res?.data?.AccountSearchFromCookies);
      }
    });
    if (userData && userData?.userDetails && userData?.userDetails.length > 0 && userData?.userDetails[0]?.Account_ID) {
      setIsAccountID(true);
    }
  }, []);

  const { data } = useQuery(AccountTrackingBalanceAndPlan, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const formattedToday = dd + "/" + mm + "/" + yyyy;

  function deleteCookie(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;";
  }

  const handleLogOut = () => {
    sessionStorage.removeItem("userData");
    sessionStorage.removeItem("tokenf");
    sessionStorage.removeItem("userRights");
    sessionStorage.removeItem("CompanyCode");
    sessionStorage.removeItem("LicenseeCode");
    sessionStorage.removeItem("BranchCode");
    sessionStorage.removeItem("SelectedFinancialYear");
    sessionStorage.removeItem("monthID");
    sessionStorage.removeItem("openModal");
    sessionStorage.removeItem("SelectedFromDate");
    sessionStorage.removeItem("SelectedToDate");
    dispatch({ type: "Login", payload: {} });
    navigate("/login");
    // socket.disconnect();
  };

  const openAccountDetails = () => {
    setShow(true);
  };

  const handleUserDataRefresh = async () => {
    const LicenseCode = sessionStorage.getItem("LicenseeCode");
    const userData = JSON.parse(sessionStorage.getItem("userData"));

    if (LicenseCode && userData?.userDetails?.length > 0) {
      const userName = userData?.userDetails[0]?.UserName;

      fetchLoginQueryResult({
        variables: {
          loginInput: { UserName: userName, LicenseeCode: LicenseCode, Password: "" },
        },
      }).then((res) => {
        if (res?.data?.login) {
          sessionStorage.removeItem("LicenseeCode");
          sessionStorage.removeItem("userData");
          sessionStorage.removeItem("tokenf");
          sessionStorage.removeItem("userRights");
          sessionStorage.removeItem("CompanyCode");
          sessionStorage.removeItem("BranchCode");

          sessionStorage.setItem("LicenseeCode", res.data.login.LicenseeCode);
          sessionStorage.setItem("userData", JSON.stringify(res.data.login));
          sessionStorage.setItem("tokenf", res.data.login.token);
          sessionStorage.setItem("userRights", JSON.stringify(res.data.login.PageRightsAccess));

          let compObj = {
            Name: res.data.login.userDetails[0]?.Default_Company?.Name,
            id: res?.data?.login?.userDetails[0]?.Default_Company?._id,
            CompanyCode: res?.data?.login?.userDetails[0]?.Default_Company?.Unique_Id,
            CompanyCodeName: res?.data?.login?.userDetails[0]?.Default_Company?.Company_Code,
            GST_Number: res?.data?.login?.userDetails[0]?.Default_Company?.GST_Number,
            Pincode: res?.data?.login?.userDetails[0]?.Default_Company?.Pincode,
            State: res?.data?.login?.userDetails[0]?.Default_Company?.State,
          };
          let branchObj = {
            Name: res?.data?.login?.userDetails[0]?.Default_Branch?.Name,
            id: res?.data?.login?.userDetails[0]?.Default_Branch?._id,
            BranchCode: res?.data?.login?.userDetails[0]?.Default_Branch?.Unique_Id,
            GST_Number: res?.data?.login?.userDetails[0]?.Default_Branch?.GST_Number,
            Search_Value: res?.data?.login?.userDetails[0]?.Default_Branch?.Search_Value,
          };
          sessionStorage.setItem("CompanyCode", JSON.stringify(compObj));
          sessionStorage.setItem("BranchCode", JSON.stringify(branchObj));
          // console.log(compObj, branchObj, "branchObjbranchObj");
          dispatch({
            type: "ChangeCompanyAndBranch",
            payload: { ...compObj, ...branchObj },
          });

          dispatch({ type: "Login", payload: res.data });
          window.location.reload(true);
        }
      });
    }
  };

  return (
    <div className="userInfo">
      <img src={props.src} className="emt_logo" alt="org_img" />
      <div>
        <p className="organization">{props.orgnization}</p>
        <p className="usernamediv">
          <span className="usernamekey">Username</span> : {props.username}
        </p>
        <p className="accessdiv">
          Access code : <span className="accesscode">{props.accesscode}</span>
        </p>
        <p className="datediv">
          Date : <span className="date">{formattedToday}</span>
        </p>
        {isAccountID && (
          <>
            <p className="usernamediv">
              <span className="usernamekey">Current Plan</span> :{" "}
              {accountData && accountData?.planSubscription && accountData?.planSubscription?.length > 0
                ? accountData?.planSubscription[0]?.subscriptionType
                : ""}
            </p>
            <p className="usernamediv">
              <span className="usernamekey">Tracking Days Balance</span> :{" "}
              {accountData && accountData?.TrackingBalance ? accountData?.TrackingBalance?.Tracking_Balance : ""}
            </p>
          </>
        )}

        <div className="change">
          {/* Refresh Page Button */}
          <button className="btn" onClick={handleUserDataRefresh}>
            {loginQueryLoading ? (
              <Button type="" name="modalbutton" text={<Spinner />} action="" disabled={true} children="" />
            ) : (
              "Refresh Login"
            )}
          </button>
          {isAccountID && (
            <button className="btn" onClick={openAccountDetails}>
              Edit Account Details <RiShareBoxFill size="13px" />
            </button>
          )}

          <button className="btn">Change Password</button>

          <button className="btn" id="logoutbtn" onClick={handleLogOut}>
            <RiShutDownLine className="logout" /> Logout
          </button>
        </div>
      </div>
      {show && <AccountDetails TypeOfPortal={"Edit"} show={show} ParentPortalCloseFunction={() => setShow(false)} />}
    </div>
  );
}

export default UserInfo;
